/** @jsxImportSource react */
import type { SVGProps } from 'react';
const LegacyEmptyBox = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 140 140" {...props}>
    <path
      fill="#CBCFD8"
      d="m16.857 45.47 50.297-16.765a9 9 0 0 1 5.692 0l50.297 16.765-5.04 29.893H23.118z"
    />
    <path
      fill="#E2E4EA"
      d="M16.857 45.47 70 69.178l53.143-23.706-7.389 46.641a4 4 0 0 1-2.1 2.92l-41.791 21.803a4 4 0 0 1-3.72-.01l-41.23-21.803a4 4 0 0 1-2.073-2.862z"
    />
    <path
      fill="#E2E4EA"
      d="m70 69.274 53.143-23.803 7.136 8.92a2 2 0 0 1-.857 3.121L76.799 77.311a1 1 0 0 1-1.158-.345zM70 69.438 16.857 45.634l-7.321 9.513a2 2 0 0 0 .755 3.04L61.198 81.39a1 1 0 0 0 1.253-.364z"
    />
    <path
      stroke="#1E2024"
      strokeLinecap="round"
      strokeOpacity={0.8}
      d="m71.926 72.685 3.845 5.942a3 3 0 0 0 3.767 1.097l3.8-1.74M16.857 61.129l19.416 8.866M70 86.334v21.717M116.998 83.354l-.867 7.801a4 4 0 0 1-2.187 3.136l-5.803 2.902M70 38.392V63.29M122.036 60.417l-17.703 8.147M111.132 50.816 88.039 61.13M83.726 44.123c-1.193-1.8-4.447-16.638 4.807-19.334 2.422-.706 4.714 1.103 5.75 2.944 1.486 2.644-.913 6.966-3.082 6.745-1.593-.163-2.668-2.134-2.668-4.802s1.658-5.37 4.395-6.753c2.737-1.382 4.995-.538 6.673.364M21.031 70.062l1.522 9.69"
    />
    <path
      fill="#E2E4EA"
      d="M9.915 123.15a2 2 0 0 1 .699-3.04l12.02-5.811a2 2 0 0 1 1.656-.039l11.676 4.988c1.655.707 1.607 3.069-.075 3.708l-18.727 7.119a2 2 0 0 1-2.28-.63zM104.184 112.55a2 2 0 0 1 1.185-3.041l5.428-1.357c.439-.11.902-.067 1.314.12l9.649 4.399c1.382.63 1.585 2.509.37 3.42l-1.98 1.485a2 2 0 0 1-1.477.38l-11.139-1.557a2 2 0 0 1-1.393-.88z"
    />
    <path stroke="#1E2024" strokeLinecap="round" d="m13 127 2.58 2.759a2 2 0 0 0 2.131.519l3.09-1.099" />
  </svg>
);
export default LegacyEmptyBox;
